import { useParams } from 'react-router-dom';
import WidgetGallery from '../../../TemplateEditor/WidgetGallery';
import ComponentGallery from '../../../TemplateEditor/ComponentGallery';
import LayersSidebar from '../../../TemplateEditor/LayersSidebar/index';
import SlidesSidebar from '../../../TemplateEditor/SildeSorterSidebar/index';

export const WidgetSideBar = () => {
    const params: any = useParams();
    const { documentName, componentId } = params;

    return (
        <>
            {(documentName || componentId) && (
                <div className={'page-toolbar'}>
                    <WidgetGallery />
                </div>
            )}
        </>
    );
};

export const ComponentsSidebar = () => {
    const params: any = useParams();
    const { documentName, componentId } = params;

    return (
        <>
            {(documentName || componentId) && (
                <div className={'page-toolbar'}>
                    <ComponentGallery />
                </div>
            )}
        </>
    );
};

export const LayersSideBarComp = () => {
    return <LayersSidebar />;
};

export const SlidesSidebarComp = () => {
    return <SlidesSidebar />;
};
